import { Link } from "react-router-dom";
import { products } from "@/mocks/products";
import ProductCard from "@/components/base/ProductCard";

const FeaturedProducts: React.FC = () => {
  const featured = products.filter((p) => p.badge).slice(0, 8);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-2">Hand-Picked</p>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900">Featured Products</h2>
          </div>
          <Link
            to="/products"
            className="hidden sm:flex items-center gap-2 text-orange-500 font-semibold hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All 30 Products <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-gray-900 text-white font-semibold rounded-lg hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Browse All 30 Products <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
